import React, { Component } from 'react'
import { Provider } from 'react-redux'

import Router from './Router'
import Store from './actions/configureStore'

class App extends Component {
  render() {
    return (
      <Provider store={Store}>
        <Router />
      </Provider>
    )
  }
}

export default App
